export function getPersonsheat(personsheat, floorArea) {
  const result = (personsheat * 80) / floorArea
  return result
}
